import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

class ZoomController extends Component {
  constructor() {
    super()
    this.onAction = this.onAction.bind(this)
  }

  onAction(e) {
    e.preventDefault()
    this.props.onAction(e)
  }

  render() {
    return (
      <button
        type="button"
        className={`icon-button ${this.props.className}`}
        aria-label={this.props.label}
        onClick={this.onAction}
      >
        {parse(this.props.icon)}
      </button>
    )
  }
}

ZoomController.propTypes = {
  onAction: PropTypes.func,
  className: PropTypes.string,
  icon: PropTypes.string,
  label: PropTypes.string,
}

export default ZoomController
